export default __webpack_public_path__ + "static/media/paypal.4ad51a37.svg";